require('at.js/dist/js/jquery.atwho.min.js')
import atwhoConfig from './atwho-config';

export default function(options) {

  let { admin } = options;
  let events = options.events || {};

  let baseConfig = {
    apiKey: window.localStorage.FEK,
    key: window.localStorage.FEK,
    attribution: false,
    imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL', 'imageSize'],
    imageResize: true,
    imageMove: true,
    imageDefaultAlign: 'left',
    imageResizeWithPercent: true,
    imageDefaultWidth: 100,
    imageEditButtons: ['imageDisplay', 'imageAlign', 'imageInfo', 'imageRemove'],
    imageUploadURL: '/images',
    pasteAllowedStyleProps: [],
    pasteDeniedAttrs: ['class', 'id', 'style'],
    pasteDeniedTags: ['iframe', 'div'],
    htmlAllowedAttrs: ['href'],
    fileInsertButtons: ['fileBack', '|'],
    fileUploadURL: '/attachments',
    paragraphFormat: {
      N: 'Normal',
      H1: 'Heading 1',
      H2: 'Heading 2',
      H3: 'Heading 3',
      H4: 'Heading 4',
    },
    placeholderText: 'Start typing...',
    tableEditButtons: ['tableRemove', '|', 'tableHeader', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
    toolbarButtons: {
      moreText: {
        buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting', 'insertCode'],
        align: 'left',
        buttonsVisible: 2
      },
      moreParagraph: {
        buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        align: 'left',
        buttonsVisible: 2
      },
      moreRich: {
        buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
        align: 'left',
        buttonsVisible: 2
      },
      moreMisc: {
        buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'help'],
        align: 'right',
        buttonsVisible: 2
      }
    },
    toolbarButtonsSM: {
      moreText: {
        buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting', 'insertCode', 'alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote', 'alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        align: 'left',
        buttonsVisible: 6
      },
      moreMisc: {
        buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'help', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
        align: 'right',
        buttonsVisible: 2
      }
    },
    videoInsertButtons: ['videoBack', '|', 'videoByURL'],
    videoMove: false,
    videoResize: false,
    videoDefaultWidth: 640,
    zIndex: 100,
    iconsTemplate: 'font_awesome_5l',
    heightMin: 300,
    events: {
      'initialized': function (e, editor) {
        $(this.$el).atwho(atwhoConfig);
        $(this.$el).on('inserted.atwho', function(a,b,c) {
          window.$('.atwho-inserted').attr('contenteditable', true)
        })
        this.events.on('keydown', function (e) {
          if (e.which === 13 && $(this.$el).atwho('isSelecting')) {
            return false;
          }
        }, true);
      },
      ...events
    }
  };

  if (admin) {
    baseConfig['toolbarButtons']['moreMisc'].buttons.push('html');
    baseConfig['toolbarButtonsSM']['moreMisc'].buttons.push('html');
    baseConfig['htmlRemoveTags'] = ['style'];
    baseConfig['htmlAllowedTags'] = ['a', 'abbr', 'address', 'area',
      'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote',
      'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup',
      'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt',
      'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i',
      'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend',
      'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav',
      'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param',
      'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script',
      'style', 'section', 'select', 'small', 'source', 'span', 'strike',
      'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea',
      'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var',
      'video', 'video-js', 'wbr'];
    baseConfig['htmlAllowedEmptyTags'] = ['textarea', 'a', 'iframe', 'object',
      'video', 'style', 'script', '.fa', '.fr-emoticon', '.fr-inner', 'path',
      'line', 'hr', 'div', 'video-js']
    baseConfig['htmlAllowedTags'] = ['.*']
    baseConfig['htmlAllowedAttrs'] = ['.*']
  }
  return baseConfig;
}

